/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import RETAIL from '../BaseComponent/RETAIL'

class AddPaymentReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      paymentList: [],
      hasRef: false
    }
  }
  componentDidMount() {
    http.get(`public/base/type/panel/accounts`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          paymentList: response.data.object
        })
      }
    })
  }

  addPayment() {
    var detailId = sessionStorage.getItem('detailIdforAdd')
    var amount = document.getElementById('amount').value
    var bankRefrence = document.getElementById('bankRefrence').value
    var typePaymentId = document.getElementById('typePaymentId').value

    var amountError = false
    var bankRefrenceError = false
    var typePaymentIdError = false
    var formError = false
    if (amount == '') {
      formError = true
      amountError = true
      message.error('مقدار وارد شود')
    } else {
      if (!amountError) {
        this.setState({
          error: ''
        })
      }
    }

    if (typePaymentId == '') {
      formError = true
      typePaymentIdError = true
      message.error('نوع پرداخت را وارد کنید')
    } else {
      if (!typePaymentIdError) {
        this.setState({
          error: ''
        })
      }
    }
    if (this.state.hasRef && bankRefrence == '') {
      formError = true
      bankRefrenceError = true
      message.error('رفرنس را وارد کنید')
    } else {
      if (!bankRefrenceError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let findTerminalId = this.state.paymentList.find((item) => +item.id === +typePaymentId)
      let data = {
        amount: amount,

        detailId: detailId,
        typePaymentId: typePaymentId,
        bankReference: this.state.hasRef ? bankRefrence : undefined,
        terminalId: findTerminalId ? findTerminalId.terminalId : undefined
      }

      // http.post(`${RETAIL.RETAIL_OPERATOR_DELIVERYPACK_PAYMENT_ADD}`, data).then((response) => {
      //     if (response.data.error == null) {
      //         message.success(' پرداخت جدید اضافه شد');
      //         setInterval(() => {
      //             window.location.assign(`/detailsPaid/${detailId}`);
      //
      //         }, 2000)
      //     } else {
      //         message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
      //     }
      // }).catch((error) => {
      //     alert(JSON.stringify(error))
      // })
    }
  }

  changeSelect(e) {
    for (let i = 0; i < this.state.paymentList.length; i++) {
      if (this.state.paymentList[i]['id'] == e.target.value) {
        // alert(this.state.paymentList[i]['hasRef'])
        this.setState({
          hasRef: this.state.paymentList[i]['hasRef']
        })
      }
    }
    // var  target=e.target;
    // var hasRef=target.options[e.selectedIndex].hasRef;

    // alert(hasRef)
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن پرداخت</p>
            </div>
            <div className="formComponent">
              <label>
                مقدار <span className="requireFiled">*</span>
              </label>
              <input type="text" id="amount" className="form-control" />

              <label>
                نوع پرداخت<span className="requireFiled">*</span>
              </label>
              <select id="typePaymentId" className="form-control" onChange={this.changeSelect.bind(this)}>
                {/*<option value=''>-------</option>*/}
                {this.state.paymentList.map((pay, index) => (
                  <option value={pay.id}>{pay.title}</option>
                ))}
              </select>

              <label>رفرنس بانک {this.state.hasRef ? <span className="requireFiled">*</span> : ''}</label>
              <input
                type="text"
                id="bankRefrence"
                disabled={this.state.hasRef ? false : true}
                className="form-control"
              />

              <button className="btn btn-info btn-block" onClick={this.addPayment.bind(this)}>
                ثبت پرداخت
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddPaymentReport
